import { ILeagueGroupFilters } from '@/types';
import { LeagueGroupItem } from '@/models/leagueGroup';

export const useLeagueGroupStore = defineStore('leagueGroup', () => {
    const items = shallowRef<LeagueGroupItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);
    const filters = reactive<ILeagueGroupFilters>({
        name: '',
    });

    return {
        items,
        total,
        loading,
        filters,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useLeagueGroupStore, import.meta.hot));
}
